'use strict';

module.exports = function () {
  return {
    $get: ['FirebaseUtil', 'AbstractDomainClass', 'OrgIdMixin',
      function (FirebaseUtil, AbstractDomainClass, OrgIdMixin) {
        //console.log('Created  $$AbstractEvent');
        function $$AbstractEvent() {
          //AbstractDomainClass.call(this, Class, data); // args: Class, data
        }

        $$AbstractEvent.__inheritFrom = function (Class, className, collection) {
          AbstractDomainClass.__inheritFrom(Class, className, collection);
          OrgIdMixin(Class);

          Class.$constraints.addConstraints({
            date: {type: 'Date', defaultValue: null, nullable: true},
            time: {type: 'boolean', defaultValue: false}, // whether this event is time specific
            org: {type: 'string'}, // Organization ID
            createdBy: {type: 'DomainLink', domainClass: 'UserDomain'},
            dateCreated: {type: 'Date'},
            lastUpdated: {type: 'Date'}
          });


          // more methods go here;

          Class.prototype.toString = function () {
            return this.date;
          };
        };

        return $$AbstractEvent;
      }]
  };
};


// WEBPACK FOOTER //
// ./src/js/calendar/domain/$$AbstractEvent.js